import type { Point } from '../../../shared/game/world-types.js';
import type { HitImpact } from './character-hit.js';
import { deathRagdoll as tuning } from '../../../content/characters/rigs/death-ragdoll.js';

/** Cosmetic total impulse: final post-mitigation damage, not HP remaining or raw dice. */
export function deathHitImpulse(away: Point, impact: HitImpact | undefined, mass: number) {
  const length = Math.hypot(away.x, away.z);
  const direction = length > .001 ? { x: away.x / length, z: away.z / length } : { x: 0, z: -1 };
  const type = impact?.type ?? 'slashing';
  const physical = impact && (type === 'slashing' || type === 'bludgeoning' || type === 'piercing');
  if (physical && type !== 'piercing') {
    // A right-handed swing crosses right to left in the striker's frame.
    const x = direction.x; direction.x = -direction.z; direction.z = x;
  }
  const safeMass = Math.max(.001, mass);
  const speed = physical
    ? Math.min(tuning.maxHitSpeed, Math.max(0, impact.damage) * tuning.damageImpulse / safeMass)
    : tuning.impulseSpeed + (impact?.critical ? tuning.criticalSpeed : 0);
  return { direction, speed, impulse: { x: direction.x * speed * safeMass, z: direction.z * speed * safeMass } };
}
